// permissions.js
const PERMISSIONS = {
  ADD_Order: 1,
  Orders_Report: 2,
  Receiving_Orders: 3,
  Return_Item: 4,
  Return_Order: 5,
  Approve_Order: 6,
  GoTo_SpareParts_Homepage: 7,
};

export default PERMISSIONS;